<template>
  <div class="black-box-tag">
    <img class="tag-icon" :src="tagIcon" :alt="tag" @mouseenter="onMouseenter" />
    <div v-if="isMountTippyRef" ref="tippyContent" class="tippy-content-wrapper">
      <template v-if="$store.getters.loginUid === user.uid">
        <div class="active-bar" @click="handleSetting">
          <span>可关闭数据展示及更改展示标签</span>
          <span class="button">前往设置</span>
        </div>
      </template>
      <template v-if="$store.getters.loginUid !== user.uid">
        <div class="active-bar" @click="handleBind">
          <span>
            {{
              $store.state.userInfo.nikke_tag ? "开启游戏标签展示即可拥有游戏标签~" : "绑定游戏数据即可获得游戏标签~"
            }}
          </span>
          <span class="button">{{ $store.state.userInfo.nikke_tag ? "立即开启" : "立即绑定" }}</span>
        </div>
      </template>
      <div class="black-box">
        <div class="header">
          <img class="avatar" :src="blackBox.avatar" alt="头像" />
          <span class="nike">{{ blackBox.name }}</span>
          <span class="level">Lv.{{ blackBox.player_level }}</span>
          <img class="tag" :src="tagIcon" :alt="tag" />
        </div>
        <div class="body">
          <div class="item">
            <span class="value">{{ blackBox.tower_floor }}</span>
            <span class="label">塔</span>
          </div>
          <div class="item">
            <span class="value">{{ blackBox.normal_progress || 0 }}</span>
            <span class="label">普通 - 战役</span>
          </div>
          <div class="item">
            <span class="value">{{ blackBox.hard_progress || 0 }}</span>
            <span class="label">困难 - 战役</span>
          </div>
          <div class="item">
            <span class="value">{{ blackBox.avatar_frame }}</span>
            <span class="label">头像框</span>
          </div>
          <div class="item">
            <span class="value">{{ blackBox.own_nikke_cnt }}</span>
            <span class="label">妮姬</span>
          </div>
          <div class="item">
            <span class="value">{{ blackBox.costume }}</span>
            <span class="label">时装</span>
          </div>
        </div>
        <div class="footer">
          <span class="detail" @click="handleBlackBoxDetail">详细数据</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import tippy from "@/plugins/tippy";
import { openSetting, bindBlabla, blackBoxDetail } from "@/views/wiki/components/blackBox";

export default {
  name: "BlackBoxTag",
  props: {
    user: { type: Object, default: () => ({}) },
    blackBox: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      isMountTippyRef: false
    };
  },
  computed: {
    tag() {
      return this.blackBox.box_tag?.name || "";
    },
    tagIcon() {
      return this.blackBox.box_tag?.icon || "";
    }
  },
  beforeDestroy() {
    if (this.instance) {
      this.instance.destroy();
    }
  },
  mounted() {
    this.isMountTippyRef = true;
  },
  methods: {
    onMouseenter(event) {
      if (this.instance) {
        return;
      }

      /** @type {HTMLDivElement} */
      const content = this.$refs.tippyContent;
      this.instance = tippy(event.target, {
        content,
        theme: "light",
        showOnCreate: true,
        interactive: true
      });
      content.style.position = "static";
      content.style.width = "initial";
      content.style.height = "initial";
      content.style.overflow = "initial";
    },
    handleBind() {
      this.instance.hide();
      if (!this.$store.getters.loginUid) {
        // this.$message.info("请先微信登录");
        this.isLoginShow();
        return;
      }
      if (!this.$store.state.userInfo.nikke_tag) {
        bindBlabla();
        return;
      }
      openSetting();
    },
    handleSetting() {
      this.instance.hide();
      openSetting();
    },
    handleBlackBoxDetail() {
      this.instance.hide();
      if (this.$store.getters.loginUid === this.user.uid) {
        blackBoxDetail();
      } else {
        blackBoxDetail({ id: this.blackBox.id, uid: this.user.uid });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.black-box-tag {
  display: inline-block;
  .tag-icon {
    display: block;
  }
}
.tippy-content-wrapper {
  position: absolute;
  width: 0;
  height: 0;
  overflow: hidden;
  padding: 16px;
  .active-bar {
    background: #fdefda;
    color: #f09000;
    font-size: 12px;
    padding: 6px 8px;
    display: flex;
    justify-content: space-between;
    border-radius: 6px;
    margin: 4px 0;
    .button {
      text-decoration-line: underline;
    }
  }
  .black-box {
    width: 300px;
    margin: auto;
    .header {
      display: flex;
      align-items: center;
      column-gap: 8px;
      margin: 12px 0;
      .avatar {
        width: 28px;
        height: 28px;
        border-radius: 100px;
      }
      .nike,
      .level {
        color: #999999;
        font-size: 12px;
      }
      .level {
        border: 1px solid rgba(0, 0, 0, 0.15);
        padding: 0 4px;
        border-radius: 4px;
      }
      .tag {
        display: block;
      }
    }
    .body {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      align-items: center;
      justify-items: center;
      align-content: space-evenly;
      height: 112px;
      background: url("~@/assets/black_imgs/blabla-user-tip-bg.png") center/contain no-repeat;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        row-gap: 6px;
        font-size: 12px;
        .value {
          color: rgba(255, 255, 255, 0.9);
          font-weight: 600;
        }
        .label {
          color: rgba(255, 255, 255, 0.7);
        }
      }
    }
    .footer {
      text-align: center;
      padding: 12px 0 0;
      .detail {
        color: #0d99ff;
        font-size: 12px;
        text-decoration-line: underline;
      }
    }
  }
}
</style>
